import { unifiedAgentEvent } from './unifiedAgentEvent'

export const unifiedAgentEditActiveOpenedLogEvent = unifiedAgentEvent<{
  agent_id: number
}>('Unified_Agent_Edit_Active_Opened')
